import { defineMessage } from 'services/localization';

export const messages = {
    previewName: defineMessage('generating_preview_br_documentname'),
    pdfNotSupportedInBrowser: defineMessage('your_browser_does_not_support_pdf_preview'),
    cannotGenerate: defineMessage('preview_for_this_file_couldnt_be_generated'),
    downloadBtnInfo: defineMessage('download'),
};
